import { useState } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { BookmarkCheck, Trash2, ChevronDown, ChevronRight } from "lucide-react";
import api, { errMsg } from "@/lib/api";

const LABEL = { shift: "Shift", line: "Line", fg_code: "FG / Model" };

export function ImportAliases({ autoCorrected }) {
  const qc = useQueryClient();
  const [open, setOpen] = useState(false);
  const q = useQuery({ queryKey: ["import-aliases"], queryFn: async () => (await api.get("/performance/aliases")).data });
  const list = q.data || [];
  if (!list.length && !autoCorrected) return null;
  const del = async (id) => { try { await api.delete(`/performance/aliases/${id}`); qc.invalidateQueries({ queryKey: ["import-aliases"] }); toast.success("Mapping removed — the original value will show as unmatched again on the next upload"); } catch (e) { toast.error(errMsg(e)); } };
  return (
    <div className="mb-2 text-[11px]" data-testid="import-aliases">
      <button type="button" className="inline-flex items-center gap-1 rounded bg-sky-100 px-1.5 py-0.5 font-semibold text-sky-800" onClick={() => setOpen(!open)} data-testid="import-aliases-toggle">
        {open ? <ChevronDown size={11} /> : <ChevronRight size={11} />}<BookmarkCheck size={11} />
        {autoCorrected ? `${autoCorrected} row(s) auto-corrected from saved mappings` : "Saved mappings"} · {list.length} mapping(s)
      </button>
      {open && <div className="mt-1 max-h-40 overflow-auto rounded border border-sky-200 bg-white">
        <table className="w-full"><thead className="bg-slate-50 text-slate-500"><tr><th className="px-2 py-1 text-left">Field</th><th className="px-2 py-1 text-left">File value</th><th className="px-2 py-1 text-left">Mapped to</th><th className="px-2 py-1 text-left">By</th><th /></tr></thead>
          <tbody>{list.map((a) => <tr key={a.id} className="border-t border-slate-100" data-testid={`import-alias-${a.id}`}>
            <td className="px-2 py-1">{LABEL[a.field] || a.field}</td><td className="px-2 py-1 font-mono">{a.from}</td><td className="px-2 py-1 font-mono font-semibold">{a.to}</td><td className="px-2 py-1 text-slate-500">{a.by}</td>
            <td className="px-2 py-1 text-right"><button type="button" className="text-rose-600" onClick={() => del(a.id)} title="Remove mapping" data-testid={`import-alias-del-${a.id}`}><Trash2 size={11} /></button></td>
          </tr>)}</tbody></table>
        {!list.length && <div className="px-2 py-1 text-slate-500">No saved mappings.</div>}
      </div>}
    </div>
  );
}
